export default __webpack_public_path__ + "static/media/decentralized.e49db6b4.png";